module.exports = __webpack_public_path__ + "media/tts_g1_thousand.1c85b4c7.mp3";